module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/canadian-example-check-b728c55bdab08d60b12a4776634cee1f.png";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/canadian-example-check.png
// module id = 3AkI
// module chunks = 22